import { HSCInput } from './index';

const { Checkbox, Input, Switch, TextArea } = HSCInput;

export { Checkbox, Input, Switch, TextArea };
